import { render, staticRenderFns } from "./ProgramasUniversidad.vue?vue&type=template&id=bcd40286&scoped=true"
import script from "./ProgramasUniversidad.vue?vue&type=script&lang=js"
export * from "./ProgramasUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ProgramasUniversidad.vue?vue&type=style&index=0&id=bcd40286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd40286",
  null
  
)

export default component.exports